import scheduledRewardPoolFactoryAbi from "../scheduledRewardPoolFactory.json";
import ScheduledRewardPoolAbi from "../scheduledRewardPool.json";
import ERC20Abi from "../erc20.json";
import createContract from "./createContract";
import web3 from "web3";
import { toFixed } from "../helper";
import { ethers } from "ethers";

export async function getScheduledMyPools(walletAddress, network) {
  try {
    const rewardPoolFactory = await createContract(
      scheduledRewardPoolFactoryAbi,
      network.REWARDPOOL_SCHEDULE_FACTORY_PROXY_ADDRESS
    );

    const rewardPools = await rewardPoolFactory.methods
      .getRewardPoolsByUser(walletAddress)
      .call();
    return rewardPools;
  } catch (error) {
    return error;
  }
}

export async function getMyBySalt(poolUniqeIdentifier, network) {
  try {
    const rewardPoolFactory = await createContract(
      scheduledRewardPoolFactoryAbi,
      network.REWARDPOOL_SCHEDULE_FACTORY_PROXY_ADDRESS
    );

    const rewardPool = await rewardPoolFactory.methods
      .getUserPoolBySalt(poolUniqeIdentifier)
      .call();
    return rewardPool;
  } catch (error) {
    return error;
  }
}

export async function createScheduledRewardPool(
  walletAddress,
  network,
  decimals,
  eligibleAddresses,
  recipientAmounts,
  salt,
  poolName,
  startTime,
  totalReward,
  numberOfDays,
  token
) {
  let WEB3 = new web3(window.ethereum);

  try {
    // Step 1: Check for pending transactions
    const pendingNonce = await WEB3.eth.getTransactionCount(
      walletAddress,
      "pending"
    );
    const latestNonce = await WEB3.eth.getTransactionCount(
      walletAddress,
      "latest"
    );

    // Cancel all pending transactions, if any
    if (pendingNonce > latestNonce) {
      for (let nonce = latestNonce; nonce < pendingNonce; nonce++) {
        await cancelTransaction(walletAddress, nonce, 21000);
      }
    }

    // Step 2: Proceed with the contract interaction
    const rewardPoolFactory = await createContract(
      scheduledRewardPoolFactoryAbi,
      network.REWARDPOOL_SCHEDULE_FACTORY_PROXY_ADDRESS
    );
    console.log(token, "mark");
    const tokenContract = await createContract(ERC20Abi, token);
    let approvedAmount = 0;
    let calRewardAmount = [];
    const num = Math.pow(10, Number(decimals));

    for (let i = 0; i < recipientAmounts.length; i++) {
      calRewardAmount.push(recipientAmounts[i] * num);
      approvedAmount += Number(recipientAmounts[i]);
    }

    const amtToApprove = num * approvedAmount;
    const value = toFixed(amtToApprove);

    // Fetch gas price and adjust for higher priority
    let gasPrice = await WEB3.eth.getGasPrice();

    console.log(value, "mark");

    // Step 3: Approve tokens
    const approveReceipt = await tokenContract.methods
      .approve(
        network.REWARDPOOL_SCHEDULE_FACTORY_PROXY_ADDRESS,
        value.toString()
      )
      .send({
        from: walletAddress,
        gasPrice: WEB3.utils.toWei(
          (parseFloat(gasPrice) * 1).toString(),
          "wei"
        ),
      });

    // Step 4: If approve is successful, create the reward pool
    if (approveReceipt.status) {
      console.log(
        eligibleAddresses,
        recipientAmounts,
        salt,
        numberOfDays,
        poolName,
        startTime,
        totalReward,
        token,
        "marksdsdk"
      );
      const gasEstimate = await rewardPoolFactory.methods
        .createScheduledRewardPool(
          eligibleAddresses,
          recipientAmounts,
          salt,
          numberOfDays,
          poolName,
          startTime,
          totalReward,
          token
        )
        .estimateGas({
          from: walletAddress,
          gasPrice: WEB3.utils.toWei(
            (parseFloat(gasPrice) * 1.2).toString(),
            "wei"
          ),
        });

      const tx = await rewardPoolFactory.methods
        .createScheduledRewardPool(
          eligibleAddresses,
          recipientAmounts,
          salt,
          numberOfDays,
          poolName,
          startTime,
          totalReward,
          token
        )
        .send({
          from: walletAddress,
          gas: gasEstimate,
          gasPrice: WEB3.utils.toWei(
            (parseFloat(gasPrice) * 1.2).toString(),
            "wei"
          ),
        });

      const rewardPool = await getMyBySalt(salt, network);
      return { rewardPool, tx };
    }
  } catch (error) {
    // General error handling (not retrying the process, as all pending transactions are already cancelled)
    throw new Error(`Failed to create reward pool: ${error.message || error}`);
  }
}

// Function to cancel the transaction
const cancelTransaction = async (account, nonce, gasPrice) => {
  let WEB3 = new web3(window.ethereum);

  const tx = {
    from: account,
    to: account, // Sending to self with 0 value to cancel
    value: "0",
    gas: 21000,
    nonce: nonce,
    gasPrice: gasPrice,
  };

  return WEB3.eth.sendTransaction(tx);
};

export async function createScheduledRewardPoolNative(
  walletAddress,
  network,
  eligibleAddresses,
  rewardAmounts,
  salt,
  poolName,
  startTime,
  totalReward,
  numberOfDays,
  tokenAddress
) {
  let WEB3 = new web3(window.ethereum);

  try {
    // Step 1: Check for pending transactions
    //   const pendingNonce = await WEB3.eth.getTransactionCount(
    //     walletAddress,
    //     "pending"
    //   );
    //   const latestNonce = await WEB3.eth.getTransactionCount(
    //     walletAddress,
    //     "latest"
    //     );

    // Cancel all pending transactions, if any
    //   if (pendingNonce > latestNonce) {
    //     for (let nonce = latestNonce; nonce < pendingNonce; nonce++) {
    //       await cancelTransaction(walletAddress, nonce, 21000);
    //     }
    //   }

    // Step 2: Proceed with the contract interaction
    const rewardPoolFactory = await createContract(
      scheduledRewardPoolFactoryAbi,
      network.REWARDPOOL_SCHEDULE_FACTORY_PROXY_ADDRESS
    );

    // Fetch gas price and adjust for higher priority
    let gasPrice = await WEB3.eth.getGasPrice();
    const nonce = await WEB3.eth.getTransactionCount(walletAddress);

    // Step 4: If approve is successful, create the reward pool

    const gasEstimate = await rewardPoolFactory.methods
      .createScheduledRewardPool(
        eligibleAddresses,
        rewardAmounts,
        salt,
        numberOfDays,
        poolName,
        startTime,
        totalReward,
        ethers.ZeroAddress
      )
      .estimateGas({
        from: walletAddress,
        nonce: nonce,
        value: totalReward,
      });

    console.log(gasEstimate, "mark");

    const tx = await rewardPoolFactory.methods
      .createScheduledRewardPool(
        eligibleAddresses,
        rewardAmounts,
        salt,
        numberOfDays,
        poolName,
        startTime,
        totalReward,
        ethers.ZeroAddress
      )
      .send({
        from: walletAddress,
        gas: gasEstimate,
        value: totalReward,
      });

    const rewardPool = await getMyBySalt(salt, network);
    return { rewardPool, tx };
  } catch (error) {
    console.error("Error in createScheduledRewardPoolNative:", error);
    throw error;
  }
}
// Retry logic for transactions
async function sendWithRetries(method, txParams, retries = 5) {
  for (let i = 0; i < retries; i++) {
    let WEB3 = new web3(window.ethereum);
    try {
      // Send transaction
      const result = await method.send(txParams);
      return result; // If successful, return result
    } catch (error) {
      if (error.message.includes("Transaction not mined within")) {
        // Increase the gas price for retry
        const newGasPrice = WEB3.utils
          .toBN(txParams.gasPrice)
          .mul(WEB3.utils.toBN(120)) // increase gas price by 20%
          .div(WEB3.utils.toBN(100));
        txParams.gasPrice = newGasPrice.toString();
      } else {
        throw error; // Other errors should stop the process
      }
    }
  }
  throw new Error("Transaction failed after retries");
}

export async function claimReward(
  walletAddress,
  rewardPoolAddress,
  tokenAddress,
  fee
) {
  try {
    let WEB3 = new web3(window.ethereum);
    const rewardPoolContract = await createContract(
      ScheduledRewardPoolAbi,
      rewardPoolAddress
    );
    const nonce = await WEB3.eth.getTransactionCount(walletAddress, "pending");
    const gasEstimate = await rewardPoolContract.methods
      .withdraw(tokenAddress)
      .estimateGas({
        from: walletAddress,
        value: fee,
      });
    const gasPrice = await WEB3.eth.getGasPrice();

    const txParams = {
      from: walletAddress,
      value: fee,
      gas: gasEstimate,
      gasPrice: web3.utils.toWei(
        (parseFloat(gasPrice) * 1.2).toString(),
        "wei"
      ), // Increase gas price by 20%
      nonce: nonce, // Use the pending nonce
    };

    // Send transaction with retry logic
    const rewardPools = await sendWithRetries(
      rewardPoolContract.methods.withdraw(tokenAddress),
      txParams
    );

    return rewardPools;
  } catch (error) {
    throw error.data;
  }
}

export async function claimNativeReward(walletAddress, rewardPoolAddress) {
  try {
    const rewardPoolContract = await createContract(
      ScheduledRewardPoolAbi,
      rewardPoolAddress
    );
    let WEB3 = new web3(window.ethereum);
    const nonce = await WEB3.eth.getTransactionCount(walletAddress);
    console.log("nonce+++++++++", rewardPoolContract);

    let balance = await WEB3.eth.getBalance(rewardPoolAddress);
    console.log("balance+++++++++", balance);

    // Get the current block time
    const currentBlockTime = await WEB3.eth
      .getBlock("latest")
      .then((block) => block.timestamp);
    console.log("Current block time:", currentBlockTime);

    // Get the pool start time directly from the contract
    const poolStartTime = await rewardPoolContract.methods.startTime().call();
    console.log("Pool start time from contract:", poolStartTime);

    // Check if the pool has started
    const hasPoolStarted = currentBlockTime > poolStartTime;
    console.log("Has pool started?", hasPoolStarted);

    if (!hasPoolStarted) {
      throw new Error(
        `Pool has not started yet. Current time: ${currentBlockTime}, Start time: ${poolStartTime}`
      );
    }

    // Get the transaction fee from the contract
    const fee = await rewardPoolContract.methods.getTransactionFee().call();
    console.log("Transaction fee:", fee);

    // Get the current day from the contract
    try {
      const currentDay = await rewardPoolContract.methods
        .getCurrentDay()
        .call();
      console.log("Current day from contract:", currentDay);
    } catch (error) {
      console.error("Error getting current day:", error);
    }

    // Get the number of days
    const numberOfDays = await rewardPoolContract.methods.numberOfDays().call();
    console.log("Number of days:", numberOfDays);

    // Check if the pool is cancelled
    const isCancelled = await rewardPoolContract.methods.isCancelled().call();
    console.log("Is pool cancelled:", isCancelled);

    // Check if the user has already claimed today
    try {
      const hasClaimedToday = await rewardPoolContract.methods
        .hasClaimedForDay(
          walletAddress,
          await rewardPoolContract.methods.getCurrentDay().call()
        )
        .call();
      console.log("Has claimed today:", hasClaimedToday);
    } catch (error) {
      console.error("Error checking if claimed today:", error);
    }

    // Try to estimate gas with a higher gas limit
    let gasEstimate;
    try {
      gasEstimate = await rewardPoolContract.methods
        .withdraw(ethers.ZeroAddress)
        .estimateGas({
          from: walletAddress,
          nonce: nonce,
          value: fee, // Include the transaction fee
        });
      console.log("Gas estimate:", gasEstimate);
    } catch (error) {
      console.error("Gas estimation failed:", error);
      // Use a default gas limit if estimation fails
      gasEstimate = 300000;
      console.log("Using default gas limit:", gasEstimate);
    }

    // Send the transaction with the estimated gas
    const rewardPools = await rewardPoolContract.methods
      .withdraw(ethers.ZeroAddress)
      .send({
        from: walletAddress,
        nonce: nonce,
        gas: gasEstimate,
        value: fee, // Include the transaction fee
      });
    return rewardPools;
  } catch (error) {
    console.error("Error in claimNativeReward:", error);
    throw error;
  }
}

export async function getTransactionFee(rewardPoolAddress) {
  try {
    const rewardContract = await createContract(
      ScheduledRewardPoolAbi,
      rewardPoolAddress
    );
    let transactionFee = await rewardContract.methods
      .getTransactionFee()
      .call();
    return transactionFee;
  } catch (error) {
    console.error("Error fetching transaction fee:", error.message || error);
    return {
      error: true,
      message: error.message || "Unable to fetch transaction fee",
    };
  }
}

export async function checkIfClaimedToday(
  rewardPoolAddress,
  userAddress,
  rawStartTime
) {
  try {
    const rewardContract = await createContract(
      ScheduledRewardPoolAbi,
      rewardPoolAddress
    );

    let startTime =
      typeof rawStartTime === "bigint"
        ? Number(rawStartTime / 1000n)
        : Number(rawStartTime); // handle if returned in ms or already in s

    console.log(typeof startTime);

    const now = Math.floor(Date.now() / 1000); // current time in seconds
    const day = Math.floor((now - startTime) / (24 * 60 * 60)); // days since start

    if (day < 0) {
      return {
        error: true,
        message: `Reward program hasn't started yet.`,
      };
    }

    const hasClaimed = await rewardContract.methods
      .hasClaimedForDay(userAddress, day)
      .call();

    return {
      claimed: hasClaimed,
      message: hasClaimed
        ? `User has already claimed for today`
        : `User has not claimed yet for today`,
    };
  } catch (error) {
    console.error("Error checking claim status:", error.message || error);
    return {
      error: true,
      message: error.message || "Unable to check claim status",
    };
  }
}

export async function getPoolStartTime(rewardPoolAddress) {
  try {
    const rewardPoolContract = await createContract(
      ScheduledRewardPoolAbi,
      rewardPoolAddress
    );

    const startTime = await rewardPoolContract.methods.startTime().call();
    return startTime;
  } catch (error) {
    console.error("Error getting pool start time:", error);
    throw error;
  }
}
